import { LandingError } from "../../components/landing-error"


export const ErrorLanding = () => {
    return  <LandingError/>
}